import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { IonicModule } from "@ionic/angular";

@Component({
  selector: "app-survey-return",
  standalone: true,
  imports: [IonicModule],
  templateUrl: "./survey-return.component.html",
  styleUrl: "./survey-return.component.scss",
})
export class SurveyReturnComponent implements OnInit {
  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    const dest = this.route.snapshot.queryParamMap.get("dest") || "";
    const targetOrigin = window.location.origin;
    try {
      // Typeform embeds survey-return in its iframe, so parent is Typeform — post to top (the app).
      const targetWindow = window.top ?? window.parent;
      targetWindow.postMessage({ type: "typeform-ending", dest }, targetOrigin);
    } catch {
      // Top/parent may be unavailable; suggestions listener will no-op.
    }
  }
}
